<template>
  <div class="content">
    <div class="layout">
  
      <Breadcrumbs title="正文"></Breadcrumbs>
      <div class="detail-wrap">
        <div class="detail-bt">
          <h1>&nbsp;赵忠心</h1>
          <p class="sub-title">
            <span>发布时间：2022年04月26日</span>
          </p>
        </div>
        <div class="text">
  
          <div class="video">
          </div>
  
          <p style="text-indent: 2em;">中国家庭教育研究第一人，北京师范大学教科所研究员 ，中国教育学会家庭教育专业委员会理事长，国家基础教育实验中心社区与家庭教育研究所所长。</p>
        </div>
      </div>
  
    </div>
  </div>
</template>


<script>
import Breadcrumbs from './component/breadcrumb.vue';

export default {
  props: {

  },
  data() {
    return {

    }
  },
  components: {
    Breadcrumbs,

  },
  created() {

  },
  mounted() {
    document.title = '山西省第三届家庭教育指导技能大赛报名'
  },
  computed: {

  },
  methods: {


  },

}
</script>
<style lang="scss" scoped>
.content {
  margin-top: 20px;
  margin-bottom: 30px;
  min-height: 50vh;

  .layout {
    width: 1200px;
    margin: 0 auto;

    .detail-wrap {
      padding: 45px 44px 83px 43px;
      background-color: #ffffff;

      .detail-bt {
        border-bottom: 1px dashed #E5E5E5;
        padding-bottom: 20px;

        h1 {
          font-size: 24px;
          line-height: 30px;
          color: #323232;
          font-weight: bold;
          text-align: center;
        }

        .sub-title {
          text-align: center;
          line-height: 30px;
          margin-top: 14px;

          span {
            font-size: 12px;
            color: #757575;
            margin-right: 20px;
          }

          span:last-child {
            margin-right: 0;
          }
        }
      }

      .text {
        margin-top: 26px;

        p {
          font-size: 16px;
          color: #333333;
          line-height: 26px;
          margin-bottom: 25px;
          text-indent: 2em;
        }
      }
    }
  }
}
</style>
